"use strict";
/**
 * Client Billing Enums
 *
 * Enums for the client-facing billing portal where pet owners
 * request CFDI income invoices for their veterinary visits.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.INVOICE_DATE_RULE_LABELS = exports.PETCO_BRANCH_EMAILS = exports.PETCO_RFC = exports.CLIENT_INVOICE_STATUS_LABELS = exports.CLIENT_INVOICE_STATUS_VALUES = exports.InvoiceDateRule = exports.ClientInvoiceStatus = void 0;
/**
 * Status of a client invoice request through the processing pipeline.
 */
var ClientInvoiceStatus;
(function (ClientInvoiceStatus) {
    /** Request created, not yet processing */
    ClientInvoiceStatus["pending"] = "pending";
    /** Background job is running (lookup, CFDI build, stamping) */
    ClientInvoiceStatus["processing"] = "processing";
    /** CFDI stamped successfully, PDF/XML available */
    ClientInvoiceStatus["stamped"] = "stamped";
    /** Processing failed (see errorMessage) */
    ClientInvoiceStatus["failed"] = "failed";
    /** Previous month invoice — requires admin/manager authorization */
    ClientInvoiceStatus["requires_authorization"] = "requires_authorization";
    /** CFDI cancelled with SAT */
    ClientInvoiceStatus["cancelled"] = "cancelled";
})(ClientInvoiceStatus || (exports.ClientInvoiceStatus = ClientInvoiceStatus = {}));
/**
 * Date rule applied to an invoice based on ticket date vs emission date.
 */
var InvoiceDateRule;
(function (InvoiceDateRule) {
    /** Ticket date within 72h — stamp with original date */
    InvoiceDateRule["within_72h"] = "within_72h";
    /** Ticket date >72h ago, same fiscal month — stamp with today's date */
    InvoiceDateRule["same_month"] = "same_month";
    /** Ticket date >72h ago, previous fiscal month — requires authorization */
    InvoiceDateRule["previous_month"] = "previous_month";
})(InvoiceDateRule || (exports.InvoiceDateRule = InvoiceDateRule = {}));
/**
 * All ClientInvoiceStatus values as array (for dropdowns/filters)
 */
exports.CLIENT_INVOICE_STATUS_VALUES = Object.values(ClientInvoiceStatus);
/**
 * ClientInvoiceStatus labels in Spanish (for UI)
 */
exports.CLIENT_INVOICE_STATUS_LABELS = {
    [ClientInvoiceStatus.pending]: "Pendiente",
    [ClientInvoiceStatus.processing]: "Procesando",
    [ClientInvoiceStatus.stamped]: "Facturada",
    [ClientInvoiceStatus.failed]: "Error",
    [ClientInvoiceStatus.requires_authorization]: "Requiere autorización",
    [ClientInvoiceStatus.cancelled]: "Cancelada",
};
/**
 * Petco (MASCOTAS Y COMPAÑIA) — different invoice email per branch.
 * Only case that requires branch-specific emails.
 */
exports.PETCO_RFC = "MAS121116E51";
exports.PETCO_BRANCH_EMAILS = {
    URBAN: "7132ger@petco.com.mx",
    HARBOR: "7178ger@petco.com.mx",
    MONTEJO: "7154ger@petco.com.mx",
};
exports.INVOICE_DATE_RULE_LABELS = {
    [InvoiceDateRule.within_72h]: "Dentro de 72 horas",
    [InvoiceDateRule.same_month]: "Mismo mes (>72h)",
    [InvoiceDateRule.previous_month]: "Mes anterior",
};
